<template>
  <div id="data" class="page">
    <details
      class="setting-section"
      v-for="(obj, index) in settings"
      :key="obj.channel"
    >
      <summary>
        <span class="title is-4">{{ obj.channel | capitalize }}</span>
      </summary>

      <div class="title is-5 has-text-weight-normal">Status</div>
      <Checkbox
        name="status"
        title="Status"
        v-model="settingsObject[index].status"
      />

      <div class="title is-5 has-text-weight-normal">Source</div>
      <div class="columns is-multiline">
        <div
          class="column is-3-fullhd is-4-desktop is-6-tablet is-12-mobile"
          v-for="(source, ckey) in settingsObject[index].settings"
          :key="ckey"
        >
          <DataSource
            v-bind="source"
            @update="sourceUpdate(obj.channel, $event)"
          />
        </div>
      </div>

      <!-- bets-api -->
      <template v-if="obj.channel === 'bets-api'">
        <div class="title is-3 has-text-weight-bold">Crawlers</div>

        <template v-for="(row, index) of obj.settings.crawlers">
          <div class="title is-4 has-text-weight-bold" :key="index">
            {{ row.key | capitalize }}
          </div>
          <Checkbox
            :key="index"
            name="status"
            title="Status"
            v-model="obj.settings.crawlers[index].status"
          />
          <div class="columns" :key="index">
            <div class="column"></div>
          </div>
        </template>
      </template>

      <!-- non-bets-api -->
      <template v-else>
        <!-- line: Time -->
        <template v-if="obj.channel === 'line'">
          <div class="title is-5 has-text-weight-normal">Time</div>
          <div class="columns">
            <div
              class="column is-3-fullhd is-4-desktop is-6-tablet is-12-mobile"
            >
              <EditInput v-model="obj.settings.time" type="time" />
            </div>
          </div>
        </template>

        <div class="title is-5">Match list</div>

        <div class="subtitle is-5 has-text-weight-normal">URL</div>
        <div class="columns">
          <div class="column is-3-fullhd is-4-desktop is-12-mobile">
            <EditInput v-model="obj.settings.matchList.url" />
          </div>
        </div>

        <div class="columns">
          <div class="column is-half-desktop">
            <div class="columns is-multiline is-mobile">
              <div
                class="column is-2-fullhd is-3-desktop is-12-mobile control"
                v-for="(company, ckey) in companies"
                :key="ckey"
              >
                <button
                  class="button is-fullwidth"
                  v-if="['ticker', 'prematch'].includes(obj.channel)"
                  :class="{
                    'is-success': obj.settings.matchList.companies.includes(
                      company.id
                    ),
                  }"
                  @click="
                    toggleCompany(company.id, obj.settings.matchList.companies)
                  "
                >
                  <span>{{ company.name }}</span>
                </button>

                <button
                  class="button is-fullwidth"
                  v-else
                  :class="{
                    'is-success':
                      obj.settings.matchList.company === company.key,
                  }"
                  @click="obj.settings.matchList.company = company.key"
                >
                  <span>{{ company.name }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Interval for ticker / prematch -->
        <template v-if="['ticker', 'prematch'].includes(obj.channel)">
          <div class="title is-5 has-text-weight-normal">Interval</div>
          <div class="columns is-multiline is-mobile">
            <div class="column is-2-fullhd is-3-desktop is-12-mobile control">
              <label class="label has-text-weight-normal">Seconds</label>
              <input
                class="input"
                type="number"
                v-model="obj.settings.matchList.timeout"
              />
            </div>
          </div>
        </template>

        <!-- Prematch specific -->
        <template v-if="['prematch'].includes(obj.channel)">
          <div class="title is-5 has-text-weight-normal">Period</div>
          <div class="columns is-multiline is-mobile">
            <div class="column is-2-fullhd is-3-desktop is-12-mobile control">
              <label class="label has-text-weight-normal">Minutes</label>
              <input
                class="input"
                type="number"
                v-model="obj.settings.minutes"
              />
            </div>
          </div>

          <div class="title is-5 has-text-weight-normal">Move/Fixed</div>
          <div class="columns is-mobile">
            <div class="column is-2-fullhd is-3-desktop is-12-mobile control">
              <label class="label has-text-weight-normal">Fixed</label>
              <input
                class="input"
                type="number"
                step="0.1"
                v-model="obj.settings.fixed"
              />
            </div>

            <div class="column is-2-fullhd is-3-desktop is-12-mobile control">
              <label class="label has-text-weight-normal">Move Hdp</label>
              <input
                class="input"
                type="number"
                step="0.25"
                v-model="obj.settings.move.handicap"
              />
            </div>

            <div class="column is-2-fullhd is-3-desktop is-12-mobile control">
              <label class="label has-text-weight-normal">Move Total</label>
              <input
                class="input"
                type="number"
                step="0.25"
                v-model="obj.settings.move.OU"
              />
            </div>
          </div>
          <template class=" " v-for="(row, key) in obj.settings">
            <template v-if="key === 'bot'">
              <div class="columns" :key="key">
                <div class="column">
                  <table class="table is-bordered is-striped">
                    <thead>
                      <tr>
                        <th></th>
                        <th
                          class="has-text-centered"
                          colspan="2"
                          v-for="part in ['HT', 'FT']"
                          :key="part"
                        >
                          {{ part }}
                        </th>
                      </tr>

                      <tr>
                        <th>type</th>
                        <th
                          v-for="odds in ['hdp', 'total', 'hdp', 'total']"
                          :key="odds"
                        >
                          {{ odds }}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="(name, valueKey) of {
                          maxOdds: 'Max odds',
                          minOdds: 'Min odds',
                        }"
                        :key="valueKey"
                      >
                        <td>{{ name }}</td>

                        <template v-for="part in ['HT', 'FT']">
                          <template v-for="odds in ['hdp', 'total']">
                            <td :key="odds + part">
                              <input
                                v-if="['maxOdds', 'minOdds'].includes(valueKey)"
                                class="input tr-input"
                                type="number"
                                v-model="
                                  obj.settings[key][part][odds][valueKey]
                                "
                                step="0.05"
                                min="0"
                              />
                            </td>
                          </template>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </template>
          </template>

          <div class="title is-5 has-text-weight-normal">Move to Lower</div>
          <div class="columns is-mobile">
            <div class="column is-2-fullhd is-3-desktop is-12-mobile control">
              <button
                class="button level-item"
                :class="{ 'is-success': obj.settings.moveToLower }"
                @click="obj.settings.moveToLower = !obj.settings.moveToLower"
              >
                <span>Status</span>
              </button>
            </div>
          </div>

          <div class="title is-5 has-text-weight-normal">First odds</div>
          <div class="columns is-multiline is-mobile">
            <div class="column is-3-fullhd is-4-desktop is-12-mobile">
              <EditInput v-model="obj.settings.odds" />
            </div>
          </div>
        </template>

        <!-- Ticker specific -->
        <template v-if="['ticker'].includes(obj.channel)">
          <div class="title is-5 has-text-weight-normal">Max time</div>
          <div class="columns is-multiline is-mobile">
            <div class="column is-2-fullhd is-3-desktop is-12-mobile control">
              <label class="label has-text-weight-normal">HT</label>
              <input class="input" type="text" v-model="obj.settings.time.HT" />
            </div>
            <div class="column is-2-fullhd is-3-desktop is-12-mobile control">
              <label class="label has-text-weight-normal">FT</label>
              <input class="input" type="text" v-model="obj.settings.time.FT" />
            </div>
          </div>

          <div class="title is-5 has-text-weight-normal">Step</div>
          <div class="columns is-multiline is-mobile">
            <div class="column is-2-fullhd is-3-desktop is-12-mobile control">
              <label class="label has-text-weight-normal">Max</label>
              <input
                class="input"
                type="number"
                step=".01"
                v-model="obj.settings.step.max"
              />
            </div>
          </div>

          <div class="title is-5 has-text-weight-normal">Smooth Signals</div>
          <div class="columns is-multiline is-mobile">
            <div class="column is-2-fullhd is-3-desktop is-12-mobile control">
              <button
                class="button level-item"
                :class="{ 'is-success': obj.settings.smoothSignals }"
                @click="
                  obj.settings.smoothSignals = !obj.settings.smoothSignals
                "
              >
                <span>Status</span>
              </button>
            </div>
          </div>

          <div class="title is-5 has-text-weight-normal">Filter</div>
          <div class="columns is-multiline is-mobile">
            <div
              class="columns column is-multiline custom-card"
              v-for="(row, i) in obj.settings.filter"
              :key="i"
            >
              <div class="column is-full control" :key="i">
                <label class="label has-text-weight-normal">{{
                  i.toUpperCase()
                }}</label>
                <input
                  class="input"
                  type="number"
                  step=".01"
                  v-model="obj.settings.filter[i].value"
                />
              </div>

              <div class="columns column is-full custom-wraper">
                <div
                  class="column is-half-custom control"
                  v-for="part of ['HT', 'FT']"
                  :key="part"
                >
                  <template
                    v-for="(config, k) of [
                      'maxTime',
                      'over',
                      'minTime',
                      'minOdds',
                      'maxOdds',
                    ]"
                  >
                    <div
                      class="control has-text-centered"
                      :key="k"
                      v-if="k == 0"
                    >
                      {{ part }}
                    </div>

                    <div v-if="obj.settings.filter[i][config]" :key="k">
                      <p>{{ config }}</p>

                      <input
                        v-if="['over', 'minOdds', 'maxOdds'].includes(config)"
                        class="input level-item"
                        type="number"
                        v-model="obj.settings.filter[i][config][part]"
                        :step="0.05"
                      />

                      <input
                        v-else
                        class="input level-item"
                        type="number"
                        v-model="obj.settings.filter[i][config][part]"
                        :step="1"
                      />
                    </div>
                  </template>
                </div>
              </div>

              <div class="custom-card-footer">
                <Checkbox
                  v-for="(name, valueKey) in {
                    signal: 'Bot Signal',
                    noDuplicates: 'No duplicates',
                    timeAttach: 'S/T Attach',
                    autoDrop: 'Auto-drop',
                  }"
                  :key="valueKey"
                  class="mini"
                  classMarkName="big white"
                  :name="valueKey"
                  :title="name"
                  v-model="obj.settings.filter[i][valueKey]"
                />
              </div>
            </div>
            <div class="bot-footer" style="width: 100%">
              <div
                v-for="(name, valueKey) of {
                  delay: 'Delay event',
                }"
                :key="valueKey"
              >
                <Checkbox
                  v-if="['noDuplicates'].includes(valueKey)"
                  class="mini"
                  classMarkName="big white"
                  :name="valueKey"
                  :title="name"
                  v-model="obj.settings[valueKey]"
                />
                <label
                  class="label"
                  v-else-if="['deep', 'delay'].includes(valueKey)"
                >
                  <input
                    class="input input-short"
                    type="number"
                    step="1"
                    v-model="obj.settings[valueKey]"
                  />
                  {{ name }}
                </label>
              </div>
            </div>
          </div>
        </template>

        <!-- Live channel -->
        <template v-if="obj.channel === 'live'">
          <div class="subtitle is-5 has-text-weight-normal">File</div>
          <div class="columns">
            <div class="column is-3-fullhd is-4-desktop is-12-mobile">
              <EditInput v-model="obj.settings.matchList.file" />
            </div>
          </div>

          <div class="subtitle is-5 has-text-weight-normal">Indexes</div>
          <div class="columns is-multiline matchfile-settings is-mobile">
            <div class="column is-half-touch control">
              <label class="label has-text-weight-normal">Array variable</label>
              <input
                class="input"
                type="text"
                v-model="obj.settings.matchList.arrayVar"
              />
            </div>

            <template v-for="(value, name) in obj.settings.matchList.indexes">
              <template
                v-if="typeof obj.settings.matchList.indexes[name] === 'object'"
              >
                <div
                  :key="name + key"
                  class="column is-half-touch control"
                  v-for="(val, key) in obj.settings.matchList.indexes[name]"
                >
                  <label class="label has-text-weight-normal">
                    <input
                      class="input"
                      type="text"
                      v-model="obj.settings.matchList.indexes[name][key]"
                    />
                    {{ name | capitalize }}.{{ key }}
                  </label>
                </div>
              </template>

              <div
                class="column is-half-touch control"
                v-else
                :key="name + key"
              >
                <label class="label has-text-weight-normal">
                  <input
                    class="input"
                    type="text"
                    v-model="obj.settings.matchList.indexes[name]"
                  />
                  {{ name | capitalize }}
                </label>
              </div>
            </template>
          </div>
        </template>

        <!-- Line additional fields -->
        <template v-if="obj.channel === 'line'">
          <div class="subtitle is-5 has-text-weight-normal">Percent</div>
          <div class="columns">
            <div class="column is-3-fullhd is-4-desktop is-12-mobile">
              <EditInput v-model="obj.settings.matchList.percent" />
            </div>
          </div>

          <div class="subtitle is-5 has-text-weight-normal">Avg. goals</div>
          <div class="columns">
            <div class="column is-3-fullhd is-4-desktop is-12-mobile">
              <EditInput v-model="obj.settings.matchList.avg" />
            </div>
          </div>

          <div class="subtitle is-5 has-text-weight-normal">Rate</div>
          <div class="columns matchfile-settings">
            <div
              class="column is-3-fullhd is-4-desktop is-12-mobile control"
              v-for="(value, name) in obj.settings.matchList.rate"
              :key="name"
            >
              <label class="label has-text-weight-normal">{{
                name | capitalize
              }}</label>
              <input
                class="input"
                type="text"
                v-model="obj.settings.matchList.rate[name]"
              />
            </div>
          </div>
        </template>

        <!-- XPath -->
        <template
          v-if="
            obj.settings.matchList.xpath &&
            Object.keys(obj.settings.matchList.xpath).length
          "
        >
          <div class="subtitle is-5 has-text-weight-normal">XPath</div>
          <div
            class="columns"
            v-for="(value, name) in obj.settings.matchList.xpath"
            :key="name"
          >
            <div class="column is-3-fullhd is-4-desktop is-12-mobile">
              <label class="label has-text-weight-normal">{{
                name | capitalize
              }}</label>
              <EditInput v-model="obj.settings.matchList.xpath[name]" />
            </div>
          </div>
        </template>

        <!-- xG model -->
        <template v-if="obj.settings.xg && Object.keys(obj.settings.xg).length">
          <div class="title is-5">xG model</div>
          <div class="columns">
            <div
              class="column control is-1"
              v-for="(o, param) in obj.settings.xg"
              :key="param"
            >
              <label class="label">{{ param }}</label>
              <input
                class="input"
                type="number"
                v-model="obj.settings.xg[param]"
                step=".1"
              />
            </div>
          </div>
        </template>

        <!-- Match pages -->
        <template
          v-if="obj.settings.match && Object.keys(obj.settings.match).length"
        >
          <div class="title is-5">Match pages</div>

          <template v-for="(o, page) in obj.settings.match">
            <div class="title is-5 has-text-weight-normal" :key="page">
              {{ page | capitalize }} page
            </div>

            <template v-for="(value, param) in o">
              <div
                class="columns control"
                v-if="
                  ['winRate', 'odds'].includes(page) &&
                  ['open', 'close'].includes(param)
                "
                :key="param"
              >
                <div class="column">
                  <button
                    class="button level-item"
                    :class="{
                      'is-success': obj.settings.match[page][param].status,
                    }"
                    @click="setWinRate(obj.settings.match[page], param)"
                  >
                    <span>{{ param }}</span>
                  </button>
                </div>
              </div>

              <div v-else :key="param">
                <div class="subtitle is-5 has-text-weight-normal">
                  {{ param }}
                </div>

                <div
                  v-if="
                    typeof value === 'object' && typeof value.xpath !== 'object'
                  "
                  class="columns"
                >
                  <div class="column is-3-fullhd is-4-desktop is-12-mobile">
                    <EditInput
                      v-model="obj.settings.match[page][param].xpath"
                    />
                  </div>
                </div>

                <template
                  v-else-if="typeof value.xpath === 'object'"
                  v-for="(xpath, xpathKey) in value.xpath"
                >
                  <div class="columns" :key="xpathKey">
                    <div class="column is-3-fullhd is-4-desktop is-12-mobile">
                      <label class="label">{{ xpathKey }}</label>
                      <EditInput
                        v-model="
                          obj.settings.match[page][param].xpath[xpathKey]
                        "
                      />
                    </div>
                  </div>
                </template>

                <div v-else class="columns">
                  <div class="column is-3-fullhd is-4-desktop is-12-mobile">
                    <EditInput v-model="obj.settings.match[page][param]" />
                  </div>
                </div>
              </div>
            </template>
          </template>
        </template>

        <!-- Ticker detailed bots blocks (raiseBot / crashBot) -->
        <template v-if="obj.channel === 'ticker'">
          <template
            v-for="(title, key) of {
              raiseBot: 'Raise Bot',
              crashBot: 'Crash Bot',
            }"
          >
            <div class="title is-5" :key="key">{{ title }}</div>

            <!-- Raise Bot table -->
            <template v-if="key === 'raiseBot' && obj.settings[key]">
              <div class="columns" :key="key">
                <div class="column">
                  <table class="table is-bordered is-striped">
                    <thead>
                      <tr>
                        <th></th>
                        <th
                          class="has-text-centered"
                          :colspan="
                            obj.settings.raiseBot.HT.hdp.length +
                            obj.settings.raiseBot.HT.total.length
                          "
                          v-for="part in ['HT', 'FT']"
                          :key="part"
                        >
                          {{ part }}
                        </th>
                      </tr>

                      <tr>
                        <th>type</th>
                        <template v-for="part in ['HT', 'FT']">
                          <template v-for="odds in ['hdp', 'total']">
                            <th
                              :colspan="obj.settings[key][part][odds].length"
                              :key="part + odds"
                            >
                              {{ odds }}
                            </th>
                          </template>
                        </template>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="(name, valueKey) of {
                          diff: 'Odds min Diff',
                          stableBefore: 'Stable before',
                          stableAfter: 'Stable after',
                          maxOverBefore: 'Max Odds Over Before',
                          minOverBefore: 'Min Odds Over Before',
                          maxOverAfter: 'Max Odds Over After',
                          minOverAfter: 'Min Odds Over After',
                          maxHdpBefore: 'Max Odds Hdp Before',
                          minHdpBefore: 'Min Odds Hdp Before',
                          maxHdpAfter: 'Max Odds Hdp After',
                          minHdpAfter: 'Min Odds Hdp After',
                          skipMarkets: 'Skip Markets from zero',
                          timeMin: 'Time Min',
                          timeMax: 'Time Max',
                        }"
                        :key="valueKey"
                      >
                        <td>{{ name }}</td>

                        <template v-for="part in ['HT', 'FT']">
                          <template v-for="odds in ['hdp', 'total']">
                            <template
                              v-for="(data, ckey) of obj.settings[key][part][
                                odds
                              ]"
                            >
                              <td :key="ckey + odds + part">
                                <input
                                  v-if="['diff'].includes(valueKey)"
                                  class="input tr-input"
                                  type="number"
                                  v-model="data[valueKey]"
                                  step="0.25"
                                />

                                <input
                                  v-else-if="
                                    [
                                      'stableBefore',
                                      'stableAfter',
                                      'timeMin',
                                      'timeMax',
                                    ].includes(valueKey)
                                  "
                                  class="input tr-input"
                                  type="number"
                                  v-model="data[valueKey]"
                                  step="1"
                                />
                                <input
                                  v-else-if="
                                    ([
                                      'minOverBefore',
                                      'maxOverBefore',
                                      'minOverAfter',
                                      'maxOverAfter',
                                    ].includes(valueKey) &&
                                      odds !== 'hdp') ||
                                    ([
                                      'minHdpBefore',
                                      'maxHdpBefore',
                                      'minHdpAfter',
                                      'maxHdpAfter',
                                    ].includes(valueKey) &&
                                      odds === 'hdp')
                                  "
                                  class="input tr-input"
                                  type="number"
                                  v-model="data[valueKey]"
                                  step="0.1"
                                />

                                <template
                                  v-else-if="
                                    ['skipMarkets'].includes(valueKey) &&
                                    odds === 'hdp'
                                  "
                                >
                                  <div class="skip-markets-container">
                                    <div
                                      class="skip-markets-cell"
                                      v-for="(marketValue, skipIndex) in data[
                                        valueKey
                                      ]"
                                      :key="skipIndex"
                                    >
                                      <input
                                        class="input tr-input short-input"
                                        type="number"
                                        v-model.number="
                                          data[valueKey][skipIndex]
                                        "
                                        step="0.25"
                                      />
                                      <button
                                        @click="
                                          data[valueKey].splice(skipIndex, 1)
                                        "
                                      >
                                        -
                                      </button>
                                    </div>

                                    <button
                                      v-if="data[valueKey]"
                                      @click="data[valueKey].push(0)"
                                    >
                                      +
                                    </button>
                                    <button
                                      v-if="!data[valueKey]"
                                      @click="data[valueKey] = [0]"
                                    >
                                      +
                                    </button>
                                  </div>
                                </template>
                              </td>
                            </template>
                          </template>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="bot-footer bot-footer-fix" :key="key">
                <div
                  v-for="(name, valueKey) of {
                    noDuplicates: 'No duplicates',
                    deep: 'Scanning depth',
                    delay: 'Delay event',
                  }"
                  :key="valueKey"
                >
                  <Checkbox
                    v-if="['noDuplicates'].includes(valueKey)"
                    class="mini"
                    classMarkName="big white"
                    :name="valueKey"
                    :title="name"
                    v-model="obj.settings[key][valueKey]"
                  />
                  <label
                    class="label"
                    v-else-if="['deep', 'delay'].includes(valueKey)"
                  >
                    <input
                      class="input input-short"
                      type="number"
                      step="1"
                      v-model="obj.settings[key][valueKey]"
                    />
                    {{ name }}
                  </label>
                </div>
              </div>
            </template>

            <!-- Crash Bot table -->
            <template v-if="key === 'crashBot'">
              <div class="columns" :key="key">
                <div class="column">
                  <table class="table is-bordered is-striped">
                    <thead>
                      <tr>
                        <th></th>
                        <th
                          class="has-text-centered"
                          colspan="2"
                          v-for="part in ['HT', 'FT']"
                          :key="part"
                        >
                          {{ part }}
                        </th>
                      </tr>

                      <tr>
                        <th>type</th>
                        <th
                          v-for="odds in ['hdp', 'total', 'hdp', 'total']"
                          :key="odds"
                        >
                          {{ odds }}
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="(name, valueKey) of {
                          maxValue: 'Max Value',
                          minOdds: 'Min odds',
                          maxOdds: 'Max odds',
                          reverseMarket: 'Reverse Market',
                          skipMarkets: 'Skip Market',
                          timeMin: 'Time Min',
                          timeMax: 'Time Max',
                        }"
                        :key="valueKey"
                      >
                        <td>{{ name }}</td>

                        <template v-for="part in ['HT', 'FT']">
                          <template v-for="odds in ['hdp', 'total']">
                            <td :key="odds + part">
                              <input
                                v-if="
                                  ['maxValue', 'minOdds', 'maxOdds'].includes(valueKey)
                                "
                                class="input tr-input"
                                type="number"
                                v-model="
                                  obj.settings[key][part][odds][valueKey]
                                "
                                step="0.05"
                                min="0"
                              />

                              <input
                                v-if="['timeMax', 'timeMin'].includes(valueKey)"
                                class="input tr-input"
                                type="number"
                                v-model="
                                  obj.settings[key][part][odds][valueKey]
                                "
                                min="1"
                              />

                              <Checkbox
                                v-else-if="
                                  ['reverseMarket'].includes(valueKey) &&
                                  odds == 'hdp'
                                "
                                class="mini white"
                                classMarkName="big white"
                                name="status"
                                title="Status"
                                v-model="
                                  obj.settings[key][part][odds][valueKey]
                                "
                              />

                              <template
                                v-else-if="['skipMarkets'].includes(valueKey)"
                              >
                                <div class="skip-markets-container">
                                  <div
                                    class="skip-markets-cell"
                                    v-for="(marketValue, skipIndex) in obj
                                      .settings[key][part][odds][valueKey]"
                                    :key="skipIndex"
                                  >
                                    <input
                                      class="input tr-input short-input"
                                      type="number"
                                      v-model.number="
                                        obj.settings[key][part][odds][valueKey][
                                          skipIndex
                                        ]
                                      "
                                      step="0.25"
                                    />
                                    <button
                                      @click="
                                        obj.settings[key][part][odds][
                                          valueKey
                                        ].splice(skipIndex, 1)
                                      "
                                    >
                                      -
                                    </button>
                                  </div>

                                  <button
                                    v-if="
                                      obj.settings[key][part][odds][valueKey]
                                    "
                                    @click="
                                      obj.settings[key][part][odds][
                                        valueKey
                                      ].push(0)
                                    "
                                  >
                                    +
                                  </button>
                                  <button
                                    v-if="
                                      !obj.settings[key][part][odds][valueKey]
                                    "
                                    @click="
                                      obj.settings[key][part][odds][valueKey] =
                                        [0]
                                    "
                                  >
                                    +
                                  </button>
                                </div>
                              </template>
                            </td>
                          </template>
                        </template>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="bot-footer bot-footer-fix" :key="key">
                <div
                  v-for="(name, valueKey) of {
                    showLiveOdd: 'Show live odd',
                    noDuplicates: 'No duplicates',
                    deep: 'Scanning deep',
                    delay: 'Delay event',
                  }"
                  :key="valueKey"
                >
                  <Checkbox
                    v-if="['showLiveOdd', 'noDuplicates'].includes(valueKey)"
                    class="mini"
                    classMarkName="big white"
                    :name="valueKey"
                    :title="name"
                    v-model="obj.settings[key][valueKey]"
                  />
                  <label
                    class="label"
                    v-else-if="['deep', 'delay'].includes(valueKey)"
                  >
                    <input
                      class="input input-short"
                      type="number"
                      step="1"
                      v-model="obj.settings[key][valueKey]"
                    />
                    {{ name }}
                  </label>
                </div>
              </div>
            </template>

            <!-- <DataCrash v-if="key === 'crashBot'" key='crashBot'/> -->

            <!-- Company buttons for bots -->
            <div class="subtitle is-5 has-text-weight-normal" :key="key">
              Company
            </div>
            <div class="columns" :key="key">
              <div class="column is-half-desktop">
                <div class="columns is-multiline is-mobile">
                  <div
                    class="column is-2-fullhd is-3-desktop is-12-mobile control"
                    v-for="(company, ckey) in companies"
                    :key="ckey"
                  >
                    <button
                      class="button is-fullwidth"
                      v-if="['crashBot'].includes(key)"
                      :class="{
                        'is-success': obj.settings[key].companies.includes(
                          company.id
                        ),
                      }"
                      @click="
                        toggleCompany(company.id, obj.settings[key].companies)
                      "
                    >
                      <span>{{ company.name }}</span>
                    </button>

                    <button
                      class="button is-fullwidth"
                      v-else
                      :class="{
                        'is-success':
                          +obj.settings[key].company === +company.id,
                      }"
                      @click="obj.settings[key].company = company.id"
                    >
                      <span>{{ company.name }}</span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
      </template>

      <div class="control">
        <button
          class="button is-primary"
          @click="save(obj.channel)"
          :class="{ 'is-loading': isLoading }"
        >
          Save
        </button>
      </div>
    </details>
  </div>
</template>

<script>
import DataSource from "@/components/DataSource";
import EditInput from "@/components/EditInput";
import Checkbox from "@/components/Checkbox";

export default {
  name: "dataPage",
  components: {
    DataSource,
    EditInput,
    Checkbox,
  },
  computed: {
    companies() {
      return this.$store.state.company.list;
    },
    settingsObject() {
      return this.$store.state.data.settings;
    },
    settings() {
      return [...this.$store.state.data.settings].map((item) => {
        let result = { ...item };
        const active =
          result.settings.find((s) => s.status) || result.settings[0];
        // eslint-disable-next-line fp/no-mutation
        result.settings = active.settings;
        if (!result.settings.minutes && result.settings.hours)
          result.settings.minutes = result.settings.hours * 60;
        return result;
      });
    },
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    setWinRate(obj, mode) {
      const old = obj[mode].status;
      ["open", "close"].forEach((key) => (obj[key].status = false));
      obj[mode].status = old ? old : !old;
    },
    toggleCompany(id, companies) {
      const i = companies.findIndex((_id) => +_id === +id);
      if (i >= 0) {
        companies.splice(i, 1);
      } else companies.push(id);
    },
    save(channel) {
      this.isLoading = true;
      this.$store
        .dispatch("saveCrawlerSettings", channel)
        .catch((text) => {
          this.$notify({
            type: "error",
            title: "Save setting error",
            text,
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    sourceUpdate(channel, obj) {
      this.$store.commit("sourceDataUpdate", { channel, obj });
    },
  },
};
</script>

<style lang="scss">
#data {
  .setting-section {
    padding-bottom: 1rem;

    summary {
      padding: 1rem;
      background-color: rgba(0, 0, 0, 0.3);
      cursor: pointer;

      &:hover {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }

    & > .title {
      margin-top: 1rem;
    }

    .label {
      color: $defaultColor;
    }

    & > .columns {
      .field.has-addons {
        .button.is-small {
          font-size: 0.885rem;
        }
      }

      .is-align-start {
        align-content: flex-start;
      }

      &:last-child {
        margin-bottom: calc(1.5rem - 0.75rem);
      }

      &.matchfile-settings {
        .column {
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .input {
            color: $defaultColor;
            background-color: #293238;
            border: none;
          }
        }
      }
    }
  }

  .table {
    border-radius: 10px;
    border: 1px solid transparent;
    box-shadow: inset 0 1px 2px rgba(30, 30, 30, 2.1);
    border-spacing: 3px;
    overflow: hidden;

    .tr-input {
      height: 1.5rem;
      width: 85%;
    }
    .short-input {
      width: 50px;
    }
    button {
      height: 1.8rem;
    }
    .skip-markets-container {
      display: flex;
      flex-wrap: wrap;
      gap: 5px;

      .skip-markets-cell {
        display: flex;
      }
    }
  }
  .custom-card {
    border: solid 2px #0a0a0a;
    border-radius: 10px;
    padding: 0;
    margin: 5px;
    width: 340px;
    min-width: 300px;
  }
  .custom-card-footer {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    border-top: solid 2px black;
    padding-top: 10px;
    margin-top: -15px;
    width: 100%;
  }
  .custom-wraper {
    width: 100%;
    display: flex;
  }
  .is-half-custom {
    width: 50%;
  }
  .input-short {
    width: 50px;
    height: 20px;
  }
  .bot-footer {
    display: flex;
    padding: 0 10px;
    margin-bottom: 2rem;
    .label {
      font-weight: bold;
      margin-right: 10px;
    }
  }
  .bot-footer-fix {
    margin-top: -1rem;
  }
}
</style>
